module.exports = __webpack_public_path__ + "static/media/PaidSocial_Ad03-Image.3ef89d63.jpg";